import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

// Components
import BodyWrap from "../utils/BodyWrap";
import ContentDiv from "../utils/ContentDiv";
import GeneralLoader from "../GeneralLoader";
import FaqAccordian from "./FaqAccordian";

// State
import { getTranslations } from "../../store/actions/translations";
import { getFaq } from "../../store/actions/faq";

class FaqPage extends Component {
	static initialAction(store, props, translationKey = null) {
		const promises = [];
		const translationSections = ["faq"];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		const resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		return promises;
	}

	componentDidMount() {
		// If we user data from the store available, go fetch data
		if (this.props.persist) {
			this.props.getFaq();
		}
	}

	componentDidUpdate(prevProps) {
		// If store is newly persisted, fetch data
		if (this.props.persist !== prevProps.persist) {
			this.props.getFaq();
		}
	}

	componentWillMount() {
		// Grab translations if not already in store
		if (!this.props.translations.pages[this.props.translationKey]) {
			FaqPage.initialAction(null, this.props);
		}
	}

	render() {
		const { translationsLoading, translations, faqIsLoading, faq } = this.props;

		// ===================================
		//	HELMET STUFF
		// ===================================
		let helmet = null;

		let title = "";
		if (this.props.siteInfo.site) {
			title += this.props.siteInfo.site.title;
		}
		if (!!translations.pages[getTranslations]) {
			if (title !== "") title += " | ";
			title += translations.pages[getTranslations].title;
		}

		// helmet = (
		// 	<Helmet>
		// 		<title>{title}</title>
		// 		<meta property="og:title" content={title} />
		// 		<meta property="og:description" content={title} />
		// 		<meta property="twitter:title" content={title} />
		// 	</Helmet>
		// );

		return (
			<BodyWrap>
				{/* {helmet} */}
				<main>
					<div className="page-content">
						<div className="section-row">
							{translationsLoading ? (
								<GeneralLoader />
							) : !!translations.pages[this.props.translationKey] ? (
								<ContentDiv>
									{translations.pages[this.props.translationKey].content}
								</ContentDiv>
							) : null}
						</div>
						{!translationsLoading && (
							<div className="section-row">
								{!!faqIsLoading ? (
									<GeneralLoader />
								) : faq.length ? (
									<FaqAccordian faq={faq} />
								) : (
											<div>{translations.sections.no_faq_response}</div>
										)}
							</div>
						)}
					</div>
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
		faqIsLoading: state.faq.isLoading !== undefined ? state.faq.isLoading : 1,
		persist: state.persist,
		faq: !!state.faq.faq ? state.faq.faq : []
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations, getFaq }
)(FaqPage);



// WEBPACK FOOTER //
// ./src/components/faq/FaqPage.js